import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {SKILL_ZONE} from "../../../Config/ApiUrl";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('skillZone.title'),
                url: SKILL_ZONE,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                        isVisible: true,
                    },
                    {
                        title: this.$t('description'),
                        type: 'text',
                        key: 'description',
                        isVisible: true,
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-skill-zone-modal',
                        modalId: 'skill-zone-modal',
                        url: SKILL_ZONE,
                        name: 'edit',
                        modifier: row => this.$can('update_skill_zone')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'skill-zone-modal',
                        url: SKILL_ZONE,
                        name: 'delete',
                        modifier: row => this.$can('delete_skill_zone')
                    },
                ],
            }
        }
    }
}
